import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { MealPlanPdfType } from "../../../utils/api-objects/HealthPlan"
import { getMealPlanPdfs } from "../../../utils/apis/plan-service"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { usePlansStore } from "../../../utils/stores/usePlansStore"
import LoadingSpinner from "../../shared/components/Loaders"
import { MealPlanDataBox } from "./MealPlanCard"

const OldMealPlan = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const { plans } = usePlansStore()
    const mealPlans = plans.mealPlans
    const [searchParams] = useSearchParams()
    const mealPlanId = searchParams.get("id")
    const spanDate = searchParams.get("span-date")

    const navigate = useNavigate()

    const currentMealPlan = mealPlans ? mealPlans.filter(hp => hp.id === mealPlanId)[0] : null

    const [isLoading, setIsLoading] = useState(false)

    const [pdfs, setPdfs] = useState<{
        type: MealPlanPdfType,
        filename: string
        url: string
        uploaded_at: string
    }[]>([]);

    useEffect(() => {
        const fetchPdfs = async () => {
            if (!userId || !idToken) return;

            setIsLoading(true);
            setPdfs([]); // Clear previous data before fetching

            try {
                const [mealPlanPdfs, supportPdfs] = await Promise.all([
                    getMealPlanPdfs(userId, idToken, `${mealPlanId}/${MealPlanPdfType.MealPlan}`),
                    getMealPlanPdfs(userId, idToken, `${mealPlanId}/${MealPlanPdfType.SupportMaterials}`)
                ]);

                // Combine both results into a single array
                const pdfList = [
                    ...mealPlanPdfs.map(pdf => ({
                        type: MealPlanPdfType.MealPlan,
                        filename: pdf.filename,
                        url: pdf.url,
                        uploaded_at: pdf.uploaded_at,
                    })),
                    ...supportPdfs.map(pdf => ({
                        type: MealPlanPdfType.SupportMaterials,
                        filename: pdf.filename,
                        url: pdf.url,
                        uploaded_at: pdf.uploaded_at,
                    }))
                ];

                setPdfs(pdfList); // Store all PDFs in one go
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPdfs();
    }, []);

    if (!currentMealPlan) {
        return <div>
            Health Plan non trovato
        </div>
    }

    if (isLoading) {
        return (
            <LoadingSpinner />
        )
    }

    return (
        <div className="w-full h-full flex flex-col max-w-[1068px]">
            <div className="space-y-[20px] flex flex-col">
                {/* <div className="flex justify-between items-start">
                    <div>
                        <div className="font-bold text-[20px] leading-[33px]">Meal Plan passati</div>
                        <div className="font-bold text-[14px] leading-[33px]">{spanDate}</div>
                    </div>
                    <CloseButton onClick={() => navigate("/health-plan/meal-plan-history")} />
                </div> */}
                <div className="font-bold text-[14px] leading-[33px]">{spanDate}</div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                    {currentMealPlan.data.guidelines && <MealPlanDataBox title="Guidelines" data={currentMealPlan.data.guidelines.map(item => item.text)} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.recepees && <MealPlanDataBox title="Ricette" data={currentMealPlan.data.recepees.map(item => item.text)} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.nutrition_recommendations && <MealPlanDataBox title="👨‍⚕️ Commento del nutrizionista" data={currentMealPlan.data.nutrition_recommendations} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.top_hero_foods && currentMealPlan.data.top_hero_foods.length > 0 && <MealPlanDataBox title="🥙  Alimenti consigliati" data={currentMealPlan.data.top_hero_foods} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.top_integratori && currentMealPlan.data.top_integratori.length > 0 && <MealPlanDataBox title="💊 Integratori consigliati" data={currentMealPlan.data.top_integratori} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.comment && currentMealPlan.data.comment.length > 0 && <MealPlanDataBox title={"👨‍⚕️ Commento del nutrizionista"} data={[currentMealPlan.data.comment]} source={"old_meal_plan_page"} />}
                    {currentMealPlan.data.important_key_points && currentMealPlan.data.important_key_points.length > 0 && <MealPlanDataBox title={"💡 Cose importanti da tenere a mente"} data={currentMealPlan.data.important_key_points} source={"old_meal_plan_page"} />}
                </div>
                {
                    currentMealPlan.pdf_data.length > 0 &&
                    <div className="w-full flex flex-col md:flex-row space-y-[20px] md:space-y-0 md:space-x-[20px] pb-[20px]">
                        {
                            currentMealPlan.pdf_data.some(pdf => pdf.type === MealPlanPdfType.MealPlan) && (
                                <div className="flex-1 basis-1/2 min-w-0 h-fit rounded-[20px] bg-[#F5F5F5] p-[20px] space-y-[10px]">
                                    <div className="font-bold text-[16px] leading-[33px]">Meal plan</div>
                                    <div className="space-y-[10px]">
                                        {
                                            pdfs.map((pdf, index) => (
                                                pdf.type === MealPlanPdfType.MealPlan &&
                                                <div
                                                    key={index}
                                                    className="rounded-[4px] font-normal text-[16px] leading-[33px] bg-[#E7E7E7] flex justify-between items-center p-[10px] space-x-[30px]"
                                                >
                                                    <div className="truncate" title={pdf.filename}>{pdf.filename}</div>
                                                    <div
                                                        className="font-bold text-[12px] leading-[17px] text-holifya-blue cursor-pointer"
                                                        onClick={() => window.open(pdf.url, "_blank")}
                                                    >
                                                        Scarica
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            )
                        }
                        {
                            currentMealPlan.pdf_data.some((pdf) => pdf.type === MealPlanPdfType.SupportMaterials) && (
                                <div className="flex-1 basis-1/2 min-w-0 h-fit rounded-[20px] bg-[#F5F5F5] p-[20px] space-y-[10px]">
                                    <div className="font-bold text-[16px] leading-[33px]">Support</div>
                                    <div className="space-y-[10px]">
                                        {
                                            pdfs.map((pdf, index) => (
                                                pdf.type === MealPlanPdfType.SupportMaterials &&
                                                <div
                                                    key={index}
                                                    className="rounded-[4px] font-normal text-[16px] leading-[33px] bg-[#E7E7E7] flex justify-between items-center p-[10px] space-x-[30px]"
                                                >
                                                    <div className="truncate" title={pdf.filename}>{pdf.filename}</div>
                                                    <div
                                                        className="font-bold text-[12px] leading-[17px] text-holifya-blue cursor-pointer"
                                                        onClick={() => window.open(pdf.url, "_blank")}
                                                    >
                                                        Scarica
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default OldMealPlan
